import AnalyticsEvent = ToroAnalyticsEnums.AnalyticsEvent;
import AnalyticsCategory = ToroAnalyticsEnums.AnalyticsCategory;

import { Directive, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AnalyticsService } from '../../../../common/services/analytics.service';
import { BroadcastService } from '../../../../common/services/broadcast.service';
import { DashUserManagerService } from '../../../../api/dash-user/dash-user-manager.service';
import { DeviceManagerService } from '../../../../common/services/device-manager.service';
import { Intelli360ManagerService } from '../../../../api/intelli360/intelli360-manager.service';
import { take } from 'rxjs/operators';
import { ToroAnalyticsEnums } from '../../../../common/enumerations/analytics.enums';
import { ToroDashboardWidget } from '../toro-dashboard-widget';
import { ToroUtils } from '../../../../common/utils/_toro.utils';
import { TranslateService } from '@ngx-translate/core';

@UntilDestroy()
@Directive()
export abstract class Intelli360WidgetBase extends ToroDashboardWidget implements OnInit {
    protected isIntelli360UserLoggedIn = true;
    protected intelli360UserName: string;
    protected isDemoMode = false;

    // =========================================================================================================================================================
    // Ctor and Lifecycle Hooks
    // =========================================================================================================================================================

    constructor(protected analyticsService: AnalyticsService,
                protected broadcastService: BroadcastService,
                protected dashUserManager: DashUserManagerService,
                protected deviceManager: DeviceManagerService,
                protected i3Manager: Intelli360ManagerService,
                protected translateService: TranslateService,
    ) {
        super(analyticsService, broadcastService, dashUserManager, deviceManager, translateService);
    }

    ngOnInit() {
        super.ngOnInit();

        this.language = this.dashUserManager.language;

        this.broadcastService.i3UserSignedIn
            .pipe(untilDestroyed(this))
            .subscribe(() => {
                this.isIntelli360UserLoggedIn = true;
                this.setIntelli360UserName();
                this.getWidgetData(false);
            });

        // this.dashUserManager.dashUserPreferencesChange
        //     .pipe(untilDestroyed(this))
        //     .subscribe(() => this.language = this.dashUserManager.language);

        this.setIntelli360UserName();
    }

    // =========================================================================================================================================================
    // Protected Members
    // =========================================================================================================================================================

    protected setIntelli360UserName() {
        this.i3Manager.getMyTurfUserName()
            .pipe(take(1))
            .subscribe(i3UserName => this.intelli360UserName = i3UserName);
    }

    protected setWidgetMenu() {
        super.setWidgetMenu();

        this.widgetMenuItems.unshift(
            { label: ToroUtils.Translate.instant('STRINGS.SIGN_IN_TO_I3'), icon: 'pi pi-fw pi-sign-in', command: this.doI3Login.bind(this) },
            { separator: true }
        );
    }

    protected onLaunchModalWidget() {
        if (this.isDemoMode) { return;}

        super.onLaunchModalWidget();
    }

    // =========================================================================================================================================================
    // Event Handlers
    // =========================================================================================================================================================

    private doI3Login() {
        window.location.href = this.i3Manager.loginUrl;
        this.analyticsService.widgetEvent(AnalyticsEvent.Intelli360WidgetSignIn, AnalyticsCategory.Interaction, this.analyticsWidgetName);
    }
}

